import {
  CustomImage,
  TextCustom,
  TextWeight,
} from '@vw-marketing/us-components';
import React from 'react';
import { useFeatureAppConfig } from '../../hooks/use-feature-app-config';
import { AppConstants } from '../../utils/app-constants';
import {
  StyledCaption,
  StyledDisabledSlide,
  StyledThumbnail,
  StyledThumbnailWrapper,
} from './styles';

interface VideoThumbnailSlideProps {
  readonly videoId?: string;
  readonly captionText?: string;
  readonly isDisabled?: boolean;
  readonly altText?: string;
  onClick?: () => void;
}

export const VideoThumbnailSlide: React.FC<VideoThumbnailSlideProps> = (
  props,
) => {
  const { faHostServerUrl = '' } = useFeatureAppConfig();
  const { videoId, captionText, isDisabled, altText, onClick, ...otherProps } =
    props;
  const imageUrl = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;

  if (isDisabled)
    return (
      <StyledDisabledSlide
        className="thumbnail-wrapper-disabled"
        {...otherProps}
      />
    );
  return (
    <StyledThumbnailWrapper
      className="thumbnail-wrapper"
      {...otherProps}
      onClick={onClick}
    >
      <StyledThumbnail
        className="video-thumbnail"
        data-testid="video-thumbnail-element"
      >
        <CustomImage
          alt={altText ? altText : ''}
          srcPlaceholder={AppConstants.PlaceHolder480x216 as string}
          srcErrorImage={
            (faHostServerUrl + AppConstants.Ngw6Logo480x216) as string
          }
          src={imageUrl}
        />
      </StyledThumbnail>
      <StyledCaption className="video-thumbnail-caption">
        <TextCustom style={{ fontWeight: TextWeight.regular }}>
          {captionText}
        </TextCustom>
      </StyledCaption>
    </StyledThumbnailWrapper>
  );
};
